import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const IncreaseInSchoolEnrollmentsAttendance = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Increase in school enrollments / attendance (%)" />
    </Box>
  );
};
